import { CreateEmploymentMutationProvider } from "__legacy/queries/employments/CreateEmploymentMutationProvider";
import { UserQueryProvider } from "__legacy/queries/users/UserQueryProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { EmploymentForm, onError, onFinish } from "./EmploymentForm";

export const New: React.FC<{}> = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <UserQueryProvider variables={{ id: userId }}>
      {({ user }) => (
        <CreateEmploymentMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`New Employment for ${user.email}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../../")}>Back to user</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <EmploymentForm
                  action="create"
                  form={form}
                  handler={onFinish(mutate, { userId }, {})}
                  values={{}}
                  errors={errors}
                  user={user}
                />
              </Layout.Content>
            </Fragment>
          )}
        </CreateEmploymentMutationProvider>
      )}
    </UserQueryProvider>
  );
};
